import { Size } from "@react-three/fiber";
import * as THREE from "three";

export const GAIA_BACKGROUND_COLOR = "#f8f8f8";
export const GAIA_FOV = 1;
export const DEFAULT_FOV_1_OVER_TANGENT =
  1 / Math.tan((GAIA_FOV * Math.PI) / 360);
export const GAIA_ZOOM_CONSTANT = 0.0025;
export const VAULT_OBJECT_THUMBNAIL_ZOOM_CONSTANT = 40;
export const GAIA_EDIT_MODE_ZOOM_CONSTANT = 0.88;
export const HENGE_PERSPECTIVE_ZOOM_CONSTANT = 0.08;
export const HENGE_ORTHOGRAPHIC_ZOOM_CONSTANT = 8;
export const HENGE_FOCAL_OFFSET_CONSTANT = 0.0018;
export const HENGE_PERSPECTIVE_MAX_DISTANCE_CONSTANT = 18;
export const VAULT_OBJECT_MIN_DISTANCE_CONSTANT = 0.2;
export const VAULT_OBJECT_MAX_DISTANCE_CONSTANT = 3.2;
export const HENGE_ORTHOGRAPHIC_MAX_DISTANCE_CONSTANT = 9000;
export const CAPTURE_ZOOM_CONSTANT = 8;
export const GAIA_CAMERA_POSITION = new THREE.Vector3(100, 100, 100);
export const GAIA_CAMERA_DISTANCE = Math.pow(
  GAIA_CAMERA_POSITION.x ** 2 +
    GAIA_CAMERA_POSITION.y ** 2 +
    GAIA_CAMERA_POSITION.z ** 2,
  0.5,
);
export const DEFAULT_COS_ZX =
  GAIA_CAMERA_POSITION.z /
  Math.pow(
    Math.pow(GAIA_CAMERA_POSITION.x, 2) + Math.pow(GAIA_CAMERA_POSITION.z, 2),
    0.5,
  );
export const DEFAULT_SIN_Y =
  Math.pow(
    Math.pow(GAIA_CAMERA_POSITION.x, 2) + Math.pow(GAIA_CAMERA_POSITION.z, 2),
    0.5,
  ) /
  Math.pow(
    Math.pow(GAIA_CAMERA_POSITION.x, 2) +
      Math.pow(GAIA_CAMERA_POSITION.z, 2) +
      Math.pow(GAIA_CAMERA_POSITION.y, 2),
    0.5,
  );
export const DEFAULT_AZIMUTH_ANGLE = Math.acos(DEFAULT_COS_ZX);
export const DEFAULT_POLAR_ANGLE = Math.asin(DEFAULT_SIN_Y);
// export const GAIA_CAMERA_TARGET = new THREE.Vector3(0, DEFAULT_SIN_Y, 0);
// export const GAIA_CAMERA_TARGET = new THREE.Vector3(0, DEFAULT_SIN_Y, 0);
export const GAIA_CAMERA_TARGET = new THREE.Vector3(0, 0, 0);
export const HENGE_PERSPECTIVE_CAMERA_POSITION = new THREE.Vector3(2, 2, 2);
export const ZERO_POLAR_ANGLE_TOLERANCE_DEGREE = 0.1;
export const SMOOTH_TIME = 0.25;
export const DRAGGING_SMOOTH_TIME = 0.125;

export function calcZoom(size: Size): number {
  const gridLength = 4;

  const gaiaWidth = gridLength * Math.pow(2, 0.5);
  const gaiaHeight = gaiaWidth * Math.cos(DEFAULT_POLAR_ANGLE);

  const reZoom =
    GAIA_ZOOM_CONSTANT *
    Math.min(size.width / gaiaWidth, size.height / gaiaHeight);

  return reZoom;
}
